class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.hoverMediaQuery = window.matchMedia('(hover: hover) and (pointer: fine)');
    this.closeTimer = null;

    this.addEventListener('mouseenter', this.openOnHover.bind(this));
    this.addEventListener('mouseleave', this.closeOnHover.bind(this));
    this.mainDetailsToggle.querySelector('summary').addEventListener('click', this.preventPointerClick.bind(this));
  }

  openOnHover() {
    if (!this.hoverMediaQuery.matches) return;

    clearTimeout(this.closeTimer);
    this.closeSearch();

    document.querySelectorAll('.header-wrapper header-menu details[open]').forEach((details) => {
      if (details !== this.mainDetailsToggle) {
        details.removeAttribute('open');
        details.querySelector('summary').setAttribute('aria-expanded', false);
      }
    });

    this.mainDetailsToggle.setAttribute('open', '');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', true);
  }

  closeOnHover() {
    if (!this.hoverMediaQuery.matches) return;

    // Allow the pointer to cross the visual gap between the trigger and submenu.
    this.closeTimer = setTimeout(() => this.close(), 250);
  }

  preventPointerClick(event) {
    // Keep mouse users on hover while retaining keyboard activation and touch controls.
    if (this.hoverMediaQuery.matches && event.detail > 0) event.preventDefault();
  }

  closeSearch() {
    this.header?.querySelectorAll('details-modal.header__search').forEach((search) => {
      if (search.isOpen()) search.close(false);
    });
  }

  onToggle() {
    if (!this.header) return;
    if (this.mainDetailsToggle.open) this.closeSearch();
    this.header.preventHide = Boolean(this.header.querySelector('header-menu details[open]'));

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
